import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  expandTooltip: {
    id: 'course-authoring.course-outline.card.expandTooltip',
    defaultMessage: 'Collapse/Expand this card',
  },
  statusBadgeLive: {
    id: 'course-authoring.course-outline.card.status-badge.live',
    defaultMessage: 'Live',
  },
  statusBadgeGated: {
    id: 'course-authoring.course-outline.card.status-badge.gated',
    defaultMessage: 'Gated',
  },
  statusBadgePublishedNotLive: {
    id: 'course-authoring.course-outline.card.status-badge.published-not-live',
    defaultMessage: 'Published not live',
  },
  statusBadgeStaffOnly: {
    id: 'course-authoring.course-outline.card.status-badge.staff-only',
    defaultMessage: 'Staff only',
  },
  statusBadgeDraft: {
    id: 'course-authoring.course-outline.card.status-badge.draft',
    defaultMessage: 'Draft',
  },
  statusBadgeUnpublishedChanges: {
    id: 'course-authoring.course-outline.card.status-badge.draft-unpublished-changes',
    defaultMessage: 'Draft (Unpublished changes)',
  },
  altButtonEdit: {
    id: 'course-authoring.course-outline.card.button.edit.alt',
    defaultMessage: 'Edit',
  },
  menuPublish: {
    id: 'course-authoring.course-outline.card.menu.publish',
    defaultMessage: 'Publish This {type}',
  },
  menuConfigure: {
    id: 'course-authoring.course-outline.card.menu.configure',
    defaultMessage: 'Configure',
  },
  menuDuplicate: {
    id: 'course-authoring.course-outline.card.menu.duplicate',
    defaultMessage: 'Duplicate',
  },
  menuMoveUp: {
    id: 'course-authoring.course-outline.card.menu.moveup',
    defaultMessage: 'Move up',
  },
  menuMoveDown: {
    id: 'course-authoring.course-outline.card.menu.movedown',
    defaultMessage: 'Move down',
  },
  menuDelete: {
    id: 'course-authoring.course-outline.card.menu.delete',
    defaultMessage: 'Delete {type}',
  },
  menuCopy: {
    id: 'course-authoring.course-outline.card.menu.copy',
    defaultMessage: 'Copy to clipboard',
  },
  menuProctoringLinkText: {
    id: 'course-authoring.course-outline.card.menu.proctoring-settings',
    defaultMessage: 'Proctoring settings',
  },
  proctoringLinkTooltip: {
    id: 'course-authoring.course-outline.card.menu.proctoring-settings-tooltip',
    defaultMessage: 'Proctoring settings',
  },
  discussionEnabledBadgeText: {
    id: 'course-authoring.course-outline.card.badge.discussionEnabled',
    defaultMessage: 'Discussions enabled',
  },
  menuManageTags: {
    id: 'course-authoring.course-outline.card.menu.manageTags',
    defaultMessage: 'Manage tags',
  },
});

export default messages;
